import React, { useContext } from "react"
import { SpaceProfileContext } from "../context"
import * as styles from "./index.module.less"
import { format } from "date-fns"
import qs from "query-string"

const viewProfile = (
  uuid = null,
  type = "Private Offices",
  teamSize,
  moveInDate
) => {
  if (!uuid) return
  const params = {
    scroll: true,
    space_type: type,
  }
  if (teamSize) {
    params.team_size = teamSize
  }
  if (moveInDate) {
    params.team_size = format(moveInDate, "yyyy-MM-dd")
  }
  window.location.href = `${
    window.location.origin
  }/space/${uuid}?${qs.stringify(params)}`
}

export const PO = ({ openTsModal = () => null }) => {
  const {
    commonData: { teamSize, data, moveInDate },
  } = useContext(SpaceProfileContext)

  const goTo = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (!teamSize) {
      openTsModal()
      return
    }

    viewProfile(data.id, "Private Offices", teamSize, moveInDate)
  }

  const disabled = false

  if (!data.private_offices_description) return null

  return (
    <button
      onClick={goTo}
      className={`${styles.feature} ${disabled ? styles.disabled_feature : ""}`}
      disabled={disabled}
    >
      <img src={data.private_offices_icon} alt="Private Offices" />
      <div>
        <h5>Private Offices</h5>
        <p>{data.private_offices_description}</p>
      </div>
    </button>
  )
}

export const DD = () => {
  const {
    commonData: { teamSize, data, moveInDate },
  } = useContext(SpaceProfileContext)

  const goTo = () => {
    viewProfile(data.id, "Dedicated desk", teamSize || 1, moveInDate)
  }

  const disabled = false

  if (!data.dedicated_desks_description) return null

  return (
    <button
      onClick={goTo}
      className={`${styles.feature} ${disabled ? styles.disabled_feature : ""}`}
      disabled={disabled}
    >
      <img src={data.dedicated_desks_icon} alt="Dedicated Desks" />
      <div>
        <h5>Dedicated Desks</h5>
        <p>{data.dedicated_desks_description}</p>
      </div>
    </button>
  )
}

// export const OnD = () => {
//   const {
//     commonData: { data },
//   } = useContext(SpaceProfileContext)
//
//   const goTo = () => null
//
//   const disabled = false
//
//   if (
//     !data.on_demand_offices_description ||
//     process.env.GATSBY_TEMPORARY_NOT_AVAILABLE
//   )
//     return null
//
//   return (
//     <a
//       href={`/space/${data.id}`}
//       className={`${styles.feature} ${disabled ? styles.disabled_feature : ""}`}
//     >
//       <img src={data.on_demand_offices_icon} alt="On-demand Offices" />
//       <div>
//         <h5>On-demand Offices</h5>
//         <p>{data.on_demand_offices_description}</p>
//       </div>
//     </a>
//   )
// }
